
import { useIsMobile } from "@/hooks/use-mobile";
import { MobileUploadView } from "@/components/mobile/MobileUploadView";
import { Studio } from "@/components/studio/Studio";

const Index = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileUploadView />;
  }

  return <Studio />;
};

export default Index;
